import { render, staticRenderFns } from "./ModalSterilizareInstrument.vue?vue&type=template&id=107c3e0a"
import script from "./ModalSterilizareInstrument.vue?vue&type=script&lang=js"
export * from "./ModalSterilizareInstrument.vue?vue&type=script&lang=js"
import style0 from "./ModalSterilizareInstrument.vue?vue&type=style&index=0&id=107c3e0a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports